import * as d3 from "d3"
import { SvgEventHandlers } from "./types"
import { buttons } from "app/core/components/dashboard/d3/svg"

export const register = (
  svgElement: SVGSVGElement,
  handlers?: SvgEventHandlers,
  editable?: boolean,
): (() => void) => {
  if (!editable) {
    return () => {}
  }
  update(svgElement, handlers)

  return () => {
    buttons().on("drop", null)
    d3.select(svgElement).on("drop", null)
  }
}

export const update = (svgElement: SVGSVGElement, handlers?: SvgEventHandlers) => {
  d3.select(svgElement).on("drop", function (event) {
    // prevent browser's default behaviour of opening a new page showing the dragged image/object
    event.preventDefault()
    if (["svg", "image", "rect"].includes(event.target.tagName)) {
      handlers?.drop?.(event.target, event)
    }
  })
}
